var _path, _mask, _path2, _path3, _circle, _path4, _circle2, _circle3, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5921 0.953125H4.70478C2.46452 0.953125 0.648438 2.76921 0.648438 5.00946V68.8968C0.648438 71.137 2.46452 72.9531 4.70478 72.9531H68.5921C70.8324 72.9531 72.6484 71.137 72.6484 68.8968V5.00946C72.6484 2.76921 70.8324 0.953125 68.5921 0.953125Z",
    fill: "#146EB4",
    fillOpacity: 0.1,
    stroke: "#146EB4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_46503_251208",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1484 56.9531H11.1484C10.8723 56.9531 10.6484 57.177 10.6484 57.4531C10.6484 57.7293 10.8723 57.9531 11.1484 57.9531H62.1484C62.4246 57.9531 62.6484 57.7293 62.6484 57.4531C62.6484 57.177 62.4246 56.9531 62.1484 56.9531Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1484 56.9531H11.1484C10.8723 56.9531 10.6484 57.177 10.6484 57.4531C10.6484 57.7293 10.8723 57.9531 11.1484 57.9531H62.1484C62.4246 57.9531 62.6484 57.7293 62.6484 57.4531C62.6484 57.177 62.4246 56.9531 62.1484 56.9531Z",
    fill: "#146EB4",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1484 57.9531H62.1484V55.9531H11.1484V57.9531ZM62.1484 57.9531C61.8723 57.9531 61.6484 57.7293 61.6484 57.4531H63.6484C63.6484 56.6247 62.9769 55.9531 62.1484 55.9531V57.9531ZM61.6484 57.4531C61.6484 57.177 61.8723 56.9531 62.1484 56.9531V58.9531C62.9769 58.9531 63.6484 58.2816 63.6484 57.4531H61.6484ZM62.1484 56.9531H11.1484V58.9531H62.1484V56.9531ZM11.1484 56.9531C11.4246 56.9531 11.6484 57.177 11.6484 57.4531H9.64844C9.64844 58.2816 10.32 58.9531 11.1484 58.9531V56.9531ZM11.6484 57.4531C11.6484 57.7293 11.4246 57.9531 11.1484 57.9531V55.9531C10.32 55.9531 9.64844 56.6247 9.64844 57.4531H11.6484Z",
    fill: "#146EB4",
    mask: "url(#path-2-inside-1_46503_251208)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6484,
    cy: 21.9531,
    r: 5.75,
    stroke: "#146EB4",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6484 21.9531H52.6484",
    stroke: "#146EB4",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6484,
    cy: 39.9531,
    r: 5.75,
    stroke: "#146EB4",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6484,
    cy: 39.9531,
    r: 3.0625,
    fill: "#146EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6484 39.9531H52.6484",
    stroke: "#146EB4",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioActiveIcon);
export default __webpack_public_path__ + "static/media/radio-active-icon.004378b30665a5810d30fd49f6dceefa.svg";
export { ForwardRef as ReactComponent };